module.exports = __webpack_public_path__ + "static/media/cq_contrassegna_elemento2.64ca5bcb.svg";